module.exports = __webpack_public_path__ + "img/kj3.cb838acc.png";